import React, { useState } from 'react';
import {
  NumericTextBoxComponent,
  TextBoxComponent,
} from '@syncfusion/ej2-react-inputs';
import { DateTimePickerComponent } from '@syncfusion/ej2-react-calendars';
import { GlobalDropDown } from '../components/GlobalDropDown';
import GlobalDialog from '../components/GlobalDialog';
import Message from './Message/Message';
import { GetErpTypeFromConfig } from "../App";
function MassOrderEdit({
  callback,
  massiveEditDialog,
  setMassiveEditDialog,
  title,
  isEditingOrder = true,
}: {
  callback: (data: any, isEditingOrder: boolean) => void;
  massiveEditDialog: boolean;
  setMassiveEditDialog: (val: boolean) => void;
  title: string;
  isEditingOrder?: boolean;
}) {
  const [description, setDescription] = useState();
  // const [trade_id, setTradeId] = useState();
  const [start_date, setStartDate] = useState<Date>();
  const [statusCode, setStatusCode] = useState();
  const [statusId, setStatusId] = useState();
  const [priority_code, setPriorityCode] = useState();
  const [priorityId, setPriorityId] = useState();
  const [typeCode, setTypeCode] = useState();
  const [typeId, setTypeId] = useState();
  const [resp, setResp] = useState();
  const [teamCode, setTeamCode] = useState();
  const [section, setSection] = useState();
  const [reference, setReference] = useState();
  const [prontoReferenceId, setProntoReferenceId] = useState();
  const [prontoReferenceCode, setProntoReferenceCode] = useState();
  const [revisionAlias, setRevisionAlias] = useState('');
  const [revisionValue, setRevisionValue] = useState('');
  const [shift, setShift] = useState<{
    rosterCode: string;
    rosterId: string;
  }>();
  const [trade, setTrade] = useState();
  const [required, setRequired] = useState<number>();
  const [estimatedHours, setEstimatedHours] = useState<number>();
  const [endDate, setEndDate] = useState<Date>();
  const [duration, setDuration] = useState<number>();

  const [reason, setReason] = useState();
  const erpTypeName = 'MEX';
  let ERP_TYPE = GetErpTypeFromConfig();
  return (
    <>
      <GlobalDialog
        showDialog={massiveEditDialog}
        setShowDialog={(val) => setMassiveEditDialog(val)}
        header={title}
        width={'600px'}
        hideDoneButton={true}
        buttons={[
          {
            buttonModel: { content: 'Cancel' },
            click: () => setMassiveEditDialog(false),
          },
          {
            buttonModel: { content: 'Apply' },
            click: () => {
              // let date = start_date;
              // let time;
              // if (date) {
              //   const hours = date?.getHours().toString().padStart(2, '0');
              //   const minutes = date.getMinutes().toString().padStart(2, '0');
              //   time = `${hours}:${minutes}:00.000`;
              // }

              var dataOrder: any;
              var dataOperations: any;
              var operationEditingData: any;
              console.log(revisionValue)
              if (isEditingOrder === true) {
                //start_date?.setHours(start_date.getHours()+11)
                dataOrder = {
                  description,
                  scheduled_start_date: null,
                  scheduled_start_time: null,
                  status_code: statusCode,
                  reason: reason,
                  status_id: statusId,
                  priority_code,
                  priority_id: priorityId,
                  type_code: typeCode,
                  type_id: typeId,
                  order_resp_code: resp,
                  team_code: teamCode,
                  order_section_code: section,
                  site_details_1:
                    ERP_TYPE === erpTypeName ? reference : prontoReferenceId,
                  revision_code: revisionValue || undefined,
                };

                dataOperations = {
                  priority: priority_code,
                  responsibility: resp,
                  workOrderType: typeCode,
                  longDescription: description,
                  section: section,
                };
                Object.keys(dataOrder).forEach(
                  (key) => dataOrder[key] === undefined && delete dataOrder[key]
                );
                Object.keys(dataOperations).forEach(
                  (key) =>
                    dataOperations[key] === undefined &&
                    delete dataOperations[key]
                );
                let isEmpty =
                  Object.keys(dataOrder).length === 0 &&
                  dataOrder.constructor === Object;
                if (isEmpty) {
                  Message.error('Please fill at least one field');
                  return;
                }
              } else {
                operationEditingData = {
                  long_description: description,
                  scheduled_start_date: start_date,
                  scheduled_end_date: endDate,
                  required: required?.toString(),
                  estHours: estimatedHours?.toString(),
                  teamCode: teamCode,
                  tradeCode: trade,
                  shift: shift?.rosterCode,
                  shiftId: shift?.rosterId,
                  duration: duration?.toString(),
                };
                Object.keys(operationEditingData).forEach(
                  (key) =>
                    operationEditingData[key] === undefined &&
                    delete operationEditingData[key]
                );
              }

              callback(
                isEditingOrder
                  ? { dataOrder, dataOperations }
                  : operationEditingData,
                isEditingOrder ? true : false
              );
              setMassiveEditDialog(false);
            },
          },
        ]}
      >
        <div style={{marginBottom: "12px"}} className='col-md-12'>
            <div className='col-md-12'>
              <TextBoxComponent
                placeholder='Description'
                floatLabelType='Auto'
                value={description}
                onChange={(e: any) => setDescription(e.target.value)}
              />
            </div>
            {/*<div className='col-md-6'>*/}
            {/*  <DateTimePickerComponent*/}
            {/*    placeholder='Start Date'*/}
            {/*    floatLabelType='Always'*/}
            {/*    format={'dd/MM/yyyy HH:mm a'}*/}
            {/*    value={start_date}*/}
            {/*    onChange={(e: any) => {*/}
            {/*      setStartDate(e.target.value);*/}
            {/*      console.log("e.target.value: ",e.target.value)*/}
            {/*      var startDate = e.target.value;*/}
            {/*      if (estimatedHours && required && startDate) {*/}
            {/*        const endDate = new Date(*/}
            {/*          startDate.getTime() +*/}
            {/*            (estimatedHours / required) * 1000 * 3600*/}
            {/*        );*/}

            {/*        setEndDate(endDate);*/}
            {/*      }*/}
            {/*    }}*/}
            {/*  />*/}
            {/*</div>*/}
            {ERP_TYPE !== 'MEX' && isEditingOrder && (
              <div className='col-md-6'>
                <GlobalDropDown
                  id='mo-section'
                  field={{ value: 'sys_tbl_code', text: 'sys_description' }}
                  //url='system-config?where=N4'
                  url='system-config?where=N4'
                  placeHolder='Section'
                  value={section}
                  onChange={(e: any) => setSection(e.target.value)}
                  floatLabelType='Always'
                />
              </div>
            )}
            {ERP_TYPE !== 'MEX' && isEditingOrder && (
              <div className='col-md-6'>
                <GlobalDropDown
                  id='mo-reference-pronto'
                  field={{ value: 'value', text: 'value' }}
                  url='global-filter?where=workorders$reference$isEnabled€1'
                  placeHolder='Reference'
                  value={prontoReferenceId}
                  onChange={(e: any) => {
                    setProntoReferenceCode(e.target.itemData?.description);
                    setProntoReferenceId(e.target.value);
                  }}
                  floatLabelType='Always'
                />
              </div>
            )}

            {ERP_TYPE !== 'MEX' && isEditingOrder && (
              <div className='col-md-6'>
                <GlobalDropDown
                  id='mo-reason-pronto'
                  field={{ value: 'value', text: 'value' }}
                  url='global-filter?where=workorders$reason$isEnabled€1'
                  placeHolder='Hold Reason'
                  value={reason}
                  onChange={(e: any) => {
                    setReason(e.target.value);
                  }}
                  floatLabelType='Always'
                />
              </div>
            )}

            {!isEditingOrder && (<div className='col-md-6'>
              <NumericTextBoxComponent
                id='mo-reference-pronto'
                min={1}
                value={required}
                placeholder='Required'
                onChange={(e: any) => {
                  if (required && estimatedHours) {
                    setDuration(estimatedHours / e.target.value);
                  }
                  if (estimatedHours && e.target.value && start_date) {
                    const endDate = new Date(
                      start_date.getTime() +
                      (estimatedHours / e.target.value) * 1000 * 3600
                    );

                    setEndDate(endDate);
                  }
                  setRequired(e.target.value);
                }}
                floatLabelType='Always'
              />
            </div>
            )}

            {ERP_TYPE !== 'MEX' && isEditingOrder && (
              <div className='col-md-6'>
                <GlobalDropDown
                  id='mo-resp'
                  field={{ value: 'value', text: 'alias' }}
                  //url='system-config?where=P2'
                  url='global-filter?where=workorders$responsibility$isEnabled€1'
                  placeHolder='Responsibility'
                  value={resp}
                  onChange={(e: any) => setResp(e.target.value)}
                  floatLabelType='Always'
                />
              </div>
            )}

            {ERP_TYPE === erpTypeName && isEditingOrder && (
              <div className='col-md-6'>
                <TextBoxComponent
                  placeholder='Reference'
                  floatLabelType='Auto'
                  value={reference}
                  onChange={(e: any) => setReference(e.target.value)}
                />
              </div>

            )}

            {!isEditingOrder && (<div className='col-md-6'>
              <GlobalDropDown
                id='mo-team'
                field={{ text: 'team_code', value: 'team_code' }}
                url='team'
                placeHolder='Teams'
                value={teamCode}
                onChange={(e: any) => setTeamCode(e.target.value)}
                floatLabelType='Always'
              />
            </div>)}
            {!isEditingOrder && (
              <div className='col-md-6'>
                <NumericTextBoxComponent
                  id='mo-reference-pronto'
                  min={0}
                  placeholder='Estimated Hours'
                  value={estimatedHours}
                  onChange={(e: any) => {
                    if (e.target.value && required) {
                      setDuration(e.target.value / required);
                    }
                    if (e.target.value && required && start_date) {
                      const endDate = new Date(
                        start_date.getTime() +
                        (e.target.value / required) * 1000 * 3600
                      );
                      setEndDate(endDate);
                    }
                    setEstimatedHours(e.target.value);
                  }}
                  floatLabelType='Always'
                />
              </div>)}

            {!isEditingOrder && (<div className='col-md-6'>
              <GlobalDropDown
                id='mo-reason-pronto'
                field={{ value: 'rosterCode', text: 'rosterCode' }}
                url='shift'
                placeHolder='Shift'
                value={shift?.rosterCode}
                onChange={(e: any) => {
                  setShift({
                    rosterCode: e.target.itemData.rosterCode,
                    rosterId: e.target.itemData.rosterId,
                  });
                }}
                floatLabelType='Always'
              />
            </div>)}
            {isEditingOrder && (
              <div className='col-md-6'>
                <GlobalDropDown
                  id='mo-type'
                  field={{ value: 'value', text: 'alias' }}
                  //field={{ value: 'sys_tbl_code', text: 'sys_description' }}
                  //url='system-config?where=P3'
                  url='global-filter?where=workorders$type$isEnabled€1'
                  placeHolder='Type'
                  value={typeId}
                  onChange={(e: any) => {
                    setTypeCode(e.target.itemData?.description);
                    setTypeId(e.target.value);
                  }}
                  floatLabelType='Always'
                />
              </div>
            )}
            {isEditingOrder ? (
              <div className='col-md-6'>
                <GlobalDropDown
                  id='mo-status'
                  field={{ value: 'value', text: 'alias' }}
                  url='global-filter?where=workorders$status$isEnabled€1'
                  placeHolder='Status'
                  value={statusId}
                  onChange={(e: any) => {
                    const value = e.target.value;
                    const description = e.target.itemData?.description;
                    setStatusId(value);
                    if (erpTypeName !== ERP_TYPE) {
                      setStatusCode(value);
                    } else {
                      setStatusCode(description);
                    }
                  }}
                  floatLabelType='Always'
                />
              </div>
            ) : (
              <div className='col-md-6'>
                <GlobalDropDown
                  id='mo-team'
                  field={{ text: 'trade_code', value: 'trade_code' }}
                  url='trade'
                  placeHolder='Trade '
                  value={trade}
                  onChange={(e: any) => setTrade(e.target.value)}
                  floatLabelType='Always'
                />
              </div>
            )}
            {isEditingOrder && (
              <div className='col-md-6'>
                <GlobalDropDown
                  id='mo-priority'
                  field={{ value: 'value', text: 'alias' }}
                  url='global-filter?where=workorders$priority$isEnabled€1'
                  placeHolder='Priority'
                  value={priority_code}
                  onChange={(e: any) => {
                    setPriorityId(e.target.value);
                    setPriorityCode(e.target.value);
                  }}
                  floatLabelType='Always'
                />
              </div>
            )}

            {ERP_TYPE !== 'MEX' && isEditingOrder && (
              <div className='col-md-6'>
                <GlobalDropDown
                  id='mo-revision-pronto'
                  field={{ value: 'value', text: 'alias' }}
                  url='global-filter?where=workorders$revision$isEnabled€1'
                  placeHolder='Revision'
                  value={revisionAlias}
                  onChange={(e: any) => {
                    setRevisionAlias(e.target.value);
                    setRevisionValue(e?.value || '');
                  }}
                  floatLabelType='Always'
                />
              </div>
            )}
        </div>
      </GlobalDialog>
    </>
  );
}

export default MassOrderEdit;
